<ng-content select="[header]"></ng-content>
<div class="invite-existing-template-root">
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="instructions">
    <ng-content select="[instructions]"></ng-content>
  </div>
  <div class="question">
    <ng-content select="[question]"></ng-content>
  </div>
  <div class="images">
    <ng-content select="[images]"></ng-content>
  </div>
  <div class="button-section">
    <ng-content select="[button]"></ng-content>
    <ng-content select="[button]"></ng-content>
  </div>
</div>
